export default __webpack_public_path__ + "static/media/AQR.d00821d4.svg";